import { render, staticRenderFns } from "./quick_create.vue?vue&type=template&id=1288497c&"
import script from "./quick_create.vue?vue&type=script&lang=js&"
export * from "./quick_create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports